<template>
  <div v-show="showLoader" class="loader"><img src="../../assets/images/loader.gif" alt=""></div>
  <main class="main_content">
    <div class="row mb-4 align-items-center">
      <div class="col-md-8">
        <h2 class="page_title">Create Quotation: RFQ {{ rfq_id }}</h2>
      </div>
      <div class="col-md-4">
        <div class="top_btns">
          <a @click="back_rfqs" class="btn btn-gray me-2">Back</a>
        </div>
      </div>
    </div>
    <div class="card_box">
      <Form @submit="handleQuotation" :validation-schema="schema">
        <div class="vertical_tabs" v-if="manufacturing_method_count > 1">
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <button v-for="(manufacturing_method,index) in manufacturing_methods" :key="index"
                      :class="index == 0 ? 'active': '' " :id="'nav-'+index+'-tab'" data-bs-toggle="tab"
                      :data-bs-target="'#nav-'+index"
                      type="button" role="tab" aria-controls="nav-one" :aria-selected="index == 0 ? 'true': 'false'">
                {{ manufacturing_method.name }}
              </button>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
            <div v-for="(manufacturing_method,index) in manufacturing_methods" :key="index"
                 :class="index == 0 ? 'tab-pane fade show active': 'tab-pane fade' " :id="'nav-'+index" role="tabpanel"
                 :aria-labelledby="'nav-'+index+'-tab'">
              <div class="accordion detail_view_accordian" id="accordionExample">
                <!-- Item Start Here -->
                <div class="accordion_item" v-for="(product,prod_index) in products[index]" :key="prod_index">
                  <h2 class="accordion-header" id="headingOne">
                    <button :class="prod_index == 0 ? 'accordion-button' : 'accordion-button collapsed' " type="button"
                            data-bs-toggle="collapse" :data-bs-target="'#collapse'+prod_index" aria-expanded="true"
                            :aria-controls="'collapse'+prod_index">
                      {{ product.part_number }}
                    </button>
                  </h2>
                  <div :id="'collapse'+prod_index"
                       :class="prod_index == 0 ? 'accordion-collapse collapse show': 'accordion-collapse collapse'"
                       :aria-labelledby="'heading'+prod_index" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                      <div class="detail_content">
                        <div class="row">
                          <div class="col-md-3 contact_half_col">
                            <div class="detail_col">
                              <label>Quantity</label>
                              <p>{{ product.quantity }}</p>
                            </div>
                          </div>
                          <div class="col-md-3 contact_half_col">
                            <div class="detail_col">
                              <label>Priority</label>
                              <p v-if="rfqResp.priority == 1">High</p>
                              <p v-if="rfqResp.priority == 2">Medium</p>
                              <p v-if="rfqResp.priority == 3">Low</p>
                            </div>
                          </div>
                          <div class="col-md-3 contact_half_col">
                            <div class="detail_col">
                              <label>Manufacturing Method</label>
                              <p>{{ manufacturing_method.name }}</p>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="detail_col">
                              <label>Documents</label>
                              <p v-if="product.upload_supporting_doc != 'N/A' ">
                                <span class="material-icons-outlined blue_color">attachment</span>
                                <a target="_blank" v-for="(prod_images,prod_index) in product.upload_supporting_doc"
                                   :key="prod_index" :href="prod_images" class="blue_color">
                                  Document {{ prod_index + 1 }} &nbsp;
                                </a>
                              </p>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="detail_col">
                              <label class="mb-0">Notes</label>
                              <p class="font_400">{{ product.notes }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <h5 class="font_700 my-4">Price Per Item</h5>
                      <span class="qty_err" id="qty_err"></span>
                      <div class="child_table">
                        <table>
                          <thead>
                          <tr>
                            <th>Quantity</th>
                            <th style="width:400px">Price Per Item (In USD)</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(qty,qty_index) in product.quantity.split(',')" :key="qty_index">
                            <!--<td>hey baby {{ qty }}</td>-->
                            <td style="vertical-align:middle;">
                              <Field @keydown.space="preventLeadingSpace"
                                     :v-model="`formValuesProduct[${product.id}].price_per_quantity_label${qty_index}`"
                                     :name="`formValuesProduct[${product.id}].price_per_quantity_label${qty_index}`"
                                     :value="qty"
                                     class="form-control" readonly/>
                              <ErrorMessage :name="`formValuesProduct[${product.id}].price_per_quantity_label${qty_index}`"
                                            class="error-feedback"/>
                            </td>
                            <td style="vertical-align:middle;">Pieces / Delivery</td>
                            <td style="vertical-align:middle;">
                              <Field @keydown.space="preventLeadingSpace"
                                     :v-model="`formValuesProduct[${product.id}].price_per_quantity_${qty_index}`"
                                     :name="`formValuesProduct[${product.id}].price_per_quantity_${qty_index}`" class="form-control"/>
                              <ErrorMessage :name="`formValuesProduct[${product.id}].price_per_quantity_${qty_index}`"
                                            class="error-feedback"/>
                            </td>
                          </tr>
                          <!--<tr>
                            <td style="vertical-align:middle;">10 Pieces / Delivery</td>
                            <td style="vertical-align:middle;">
                              <Field @keydown.space="preventLeadingSpace"
                                     :v-model="`formValuesProduct[${product.id}].price_per_quantity_ten`"
                                     :name="`formValuesProduct[${product.id}].price_per_quantity_ten`"
                                     class="form-control"/>
                              <ErrorMessage :name="`formValuesProduct[${product.id}].price_per_quantity_ten`"
                                            class="error-feedback"/>
                            </td>
                          </tr>
                          <tr>
                            <td style="vertical-align:middle;">100 Pieces / Delivery</td>
                            <td style="vertical-align:middle;">
                              <Field @keydown.space="preventLeadingSpace"
                                     :v-model="`formValuesProduct[${product.id}].price_per_quantity_hundrad`"
                                     :name="`formValuesProduct[${product.id}].price_per_quantity_hundrad`"
                                     class="form-control"/>
                              <ErrorMessage :name="`formValuesProduct[${product.id}].price_per_quantity_hundrad`"
                                            class="error-feedback"/>
                            </td>
                          </tr>
                          <tr>
                            <td style="vertical-align:middle;">1000 Pieces / Delivery</td>
                            <td style="vertical-align:middle;">
                              <Field @keydown.space="preventLeadingSpace"
                                     :v-model="`formValuesProduct[${product.id}].price_per_quantity_thousand`"
                                     :name="`formValuesProduct[${product.id}].price_per_quantity_thousand`"
                                     class="form-control"/>
                              <ErrorMessage :name="`formValuesProduct[${product.id}].price_per_quantity_thousand`"
                                            class="error-feedback"/>
                            </td>
                          </tr>
                          <tr>
                            <td style="vertical-align:middle;">10000 Pieces / Delivery</td>
                            <td style="vertical-align:middle;">
                              <Field @keydown.space="preventLeadingSpace"
                                     :v-model="`formValuesProduct[${product.id}].price_per_quantity_ten_thousand`"
                                     :name="`formValuesProduct[${product.id}].price_per_quantity_ten_thousand`"
                                     class="form-control"/>
                              <ErrorMessage :name="`formValuesProduct[${product.id}].price_per_quantity_ten_thousand`"
                                            class="error-feedback"/>
                            </td>
                          </tr>-->
                          </tbody>
                        </table>
                      </div>

                      <hr>
                      <h5 class="font_700 my-4">Costs</h5>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="label">Tooling Cost (In USD)</label>
                            <Field @keydown.space="preventLeadingSpace"
                                   :v-model="`formValuesProduct[${product.id}].tooling_cost`"
                                   :name="`formValuesProduct[${product.id}].tooling_cost`" class="form-control"/>
                            <ErrorMessage :name="`formValuesProduct[${product.id}].tooling_cost`"
                                          class="error-feedback"/>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="label">Additional Cost (In USD)</label>
                            <Field @keydown.space="preventLeadingSpace"
                                   :v-model="`formValuesProduct[${product.id}].additional_cost`"
                                   :name="`formValuesProduct[${product.id}].additional_cost`" class="form-control"/>
                            <ErrorMessage :name="`formValuesProduct[${product.id}].additional_cost`"
                                          class="error-feedback"/>
                          </div>
                        </div>

                      </div>
                      <hr>
                      <h5 class="font_700 my-4">Delivery Milestones</h5>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="label">Sample Lead Time (in days)</label>
                            <Field @keydown.space="preventLeadingSpace"
                                   :v-model="`formValuesProduct[${product.id}].sample_lead_time`" type="number"
                                   :name="`formValuesProduct[${product.id}].sample_lead_time`" class="form-control"/>
                            <ErrorMessage :name="`formValuesProduct[${product.id}].sample_lead_time`"
                                          class="error-feedback"/>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="label">Production Lead Time (in days)<span class="required">*</span></label>
                            <Field @keydown.space="preventLeadingSpace"
                                   :v-model="`formValuesProduct[${product.id}].production_lead_time`" type="number"
                                   :name="`formValuesProduct[${product.id}].production_lead_time`"
                                   class="form-control"/>
                            <ErrorMessage :name="`formValuesProduct[${product.id}].production_lead_time`"
                                          class="error-feedback"/>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="label">Delivery (in days)<span class="required">*</span></label>
                            <Field @keydown.space="preventLeadingSpace"
                                   :v-model="`formValuesProduct[${product.id}].finish_time`" type="number"
                                   :name="`formValuesProduct[${product.id}].finish_time`" class="form-control"/>
                            <ErrorMessage :name="`formValuesProduct[${product.id}].finish_time`"
                                          class="error-feedback"/>
                          </div>
                        </div>
                      </div>
                      <hr/>
                      <h5 class="font_700 my-4">Packaging Details</h5>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="label">Packaging Type <span class="required">*</span></label>
                            <Field @keydown.space="preventLeadingSpace"
                                   :v-model="`formValuesProduct[${product.id}].packaging_type`"
                                   :name="`formValuesProduct[${product.id}].packaging_type`" type="text"
                                   class="form-control"/>
                            <ErrorMessage :name="`formValuesProduct[${product.id}].packaging_type`"
                                          class="error-feedback"/>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label class="label">Quantity/Package<span class="required">*</span></label>
                            <Field @keydown.space="preventLeadingSpace"
                                   :v-model="`formValuesProduct[${product.id}].quantity_per_box`"
                                   :name="`formValuesProduct[${product.id}].quantity_per_box`" type="number"
                                   class="form-control"/>
                            <ErrorMessage :name="`formValuesProduct[${product.id}].quantity_per_box`"
                                          class="error-feedback"/>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label class="label">Weigt/Package) <span class="required">*</span></label>
                            <Field @keydown.space="preventLeadingSpace"
                                   :v-model="`formValuesProduct[${product.id}].package_weight`"
                                   :name="`formValuesProduct[${product.id}].package_weight`" type="text"
                                   class="form-control"/>
                            <ErrorMessage :name="`formValuesProduct[${product.id}].package_weight`"
                                          class="error-feedback"/>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-group">
                            <label class="label">Unit <span class="required">*</span></label>
                            <Field :v-model="`formValuesProduct[${product.id}].package_weight_unit`"
                                   :name="`formValuesProduct[${product.id}].package_weight_unit`"
                                   as="select"
                                   class="form-control form-select">
                              <option>Select Weight Unit</option>
                              <option value="kg">Kilogram</option>
                              <option value="lb">Pound</option>
                            </Field>
                            <ErrorMessage :name="`formValuesProduct[${product.id}].package_weight_unit`"
                                          class="error-feedback"/>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="label">Packaging Length <span class="required">*</span></label>
                            <Field @keydown.space="preventLeadingSpace"
                                   :v-model="`formValuesProduct[${product.id}].package_length`" type="text"
                                   :name="`formValuesProduct[${product.id}].package_length`" class="form-control"/>
                            <ErrorMessage :name="`formValuesProduct[${product.id}].package_length`"
                                          class="error-feedback"/>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label class="label">Packaging Width <span class="required">*</span></label>
                            <Field @keydown.space="preventLeadingSpace"
                                   :v-model="`formValuesProduct[${product.id}].package_width`" type="text"
                                   :name="`formValuesProduct[${product.id}].package_width`" class="form-control"/>
                            <ErrorMessage :name="`formValuesProduct[${product.id}].package_width`"
                                          class="error-feedback"/>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label class="label">Packaging Height <span class="required">*</span></label>
                            <Field @keydown.space="preventLeadingSpace"
                                   :v-model="`formValuesProduct[${product.id}].package_height`" type="text"
                                   :name="`formValuesProduct[${product.id}].package_height`" class="form-control"/>
                            <ErrorMessage :name="`formValuesProduct[${product.id}].package_height`"
                                          class="error-feedback"/>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-group">
                            <label class="label">Unit <span class="required">*</span></label>
                            <Field :v-model="`formValuesProduct[${product.id}].package_size_unit`"
                                   :name="`formValuesProduct[${product.id}].package_size_unit`"
                                   as="select"
                                   class="form-control form-select">
                              <option>Select Unit</option>
                              <option value="mm">Millimeter</option>
                              <option value="cm">Centimeter</option>
                              <option value="in">Inches</option>
                              <option value="ft">Foot</option>
                            </Field>
                            <ErrorMessage :name="`formValuesProduct[${product.id}].package_size_unit`"
                                          class="error-feedback"/>
                          </div>
                        </div>
                      </div>
                      <hr>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label class="label">Additional Details</label>
                            <editor
                                api-key="ib23r73dw4tplnpttr0jwef67tx2w0e9m4x6mhdi4simy6uh"
                                :data-index="`${product.id}`" @keyup="(event) => onChangeTextArea(product.id,event)"
                                :v-model="`supplier_additional_details[${product.id}]`"
                                :name="`products[${index}].supplier_quotation_additional_details`"
                                :init="{
                                    menubar: false,
                                    plugins: 'lists link',
                                    toolbar: 'bold italic | bullist'
                                  }"
                            />
                            <!-- <textarea  :data-index="`${product.id}`" @change="onChangeTextArea" :v-model="`formValuesProduct[${product.id}].supplier_quotation_additional_details`" :name="`products[${index}].supplier_quotation_additional_details`" class="form-control form-area"></textarea> -->

                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="label">Attachment</label>
                            <input @change="onChangeFile" :data-index="`${product.id}`"
                                   :v-model="`formValuesProduct[${product.id}].supplier_quotation_doc`" type="file"
                                   :name="`formValuesProduct[${product.id}].supplier_quotation_doc`"
                                   class="form-control">
                          </div>
                        </div>
                      </div>
                    </div>

                  </div><!-- Item Ends Here -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion detail_view_accordian" id="accordionExample" v-if="manufacturing_method_count == 1">

          <!-- Item Start Here -->
          <div class="accordion_item" v-for="(product,prod_index) in products" :key="prod_index">
            <h2 class="accordion-header" id="headingOne">
              <button :class="prod_index == 0 ? 'accordion-button' : 'accordion-button collapsed' " type="button"
                      data-bs-toggle="collapse" :data-bs-target="'#collapse'+prod_index" aria-expanded="true"
                      :aria-controls="'collapse'+prod_index">
                {{ product.part_number }}
              </button>
            </h2>
            <div :id="'collapse'+prod_index"
                 :class="prod_index == 0 ? 'accordion-collapse collapse show': 'accordion-collapse collapse'"
                 :aria-labelledby="'heading'+prod_index" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <div class="detail_content">
                  <div class="row">
                    <div class="col-md-3 contact_half_col">
                      <div class="detail_col">
                        <label>Quantity</label>
                        <p>{{ product.quantity }}</p>
                      </div>
                    </div>
                    <div class="col-md-3 contact_half_col">
                      <div class="detail_col">
                        <label>Priority</label>
                        <p v-if="rfqResp.priority == 1">High</p>
                        <p v-if="rfqResp.priority == 2">Medium</p>
                        <p v-if="rfqResp.priority == 3">Low</p>
                      </div>
                    </div>
                    <div class="col-md-3 contact_half_col">
                      <div class="detail_col">
                        <label>Manufacturing Method</label>
                        <p>{{ manufacturing_methods[0].name }}</p>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="detail_col">
                        <label>Documents</label>
                        <p v-if="product.upload_supporting_doc != 'N/A' ">
                          <span class="material-icons-outlined blue_color">attachment</span>
                          <a target="_blank" v-for="(prod_images,prod_index) in product.upload_supporting_doc"
                             :key="prod_index" :href="prod_images" class="blue_color">
                            Document {{ prod_index + 1 }} &nbsp;
                          </a>
                        </p>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="detail_col">
                        <label class="mb-0">Notes</label>
                        <p class="font_400">{{ product.notes }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <h5 class="font_700 my-4">Price Per Item</h5>
                <div class="child_table">
                  <table>
                    <thead>
                    <tr>
                      <th colspan="2" >Quantity</th>

                      <th style="width:400px">Price Per Item (In USD)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(qty,qty_index) in product.quantity.split(',')" :key="qty_index">
<!--                      <td>hey baby {{ qty }}</td>-->
                      <td style="vertical-align:middle;">
                        <Field @keydown.space="preventLeadingSpace"
                               :v-model="`formValuesProduct[${product.id}].price_per_quantity_label${qty_index}`"
                               :name="`formValuesProduct[${product.id}].price_per_quantity_label${qty_index}`"
                               :value="qty"
                               class="form-control" readonly/>
                        <ErrorMessage :name="`formValuesProduct[${product.id}].price_per_quantity_label${qty_index}`"
                                      class="error-feedback"/>
                      </td>
                      <td style="vertical-align:middle;">Pieces / Delivery</td>
                      <td style="vertical-align:middle;">
                        <Field @keydown.space="preventLeadingSpace"
                               :v-model="`formValuesProduct[${product.id}].price_per_quantity_${qty_index}`"
                               :name="`formValuesProduct[${product.id}].price_per_quantity_${qty_index}`" class="form-control"/>
                        <ErrorMessage :name="`formValuesProduct[${product.id}].price_per_quantity_${qty_index}`"
                                      class="error-feedback"/>
                      </td>
                    </tr>


                    </tbody>
                  </table>
                </div>

                <hr>
                <h5 class="font_700 my-4">Costs</h5>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="label">Tooling Cost (In USD)</label>
                      <Field @keydown.space="preventLeadingSpace"
                             :v-model="`formValuesProduct[${product.id}].tooling_cost`"
                             :name="`formValuesProduct[${product.id}].tooling_cost`" class="form-control"/>
                      <ErrorMessage :name="`formValuesProduct[${product.id}].tooling_cost`" class="error-feedback"/>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="label">Additional Cost (In USD)</label>
                      <Field @keydown.space="preventLeadingSpace"
                             :v-model="`formValuesProduct[${product.id}].additional_cost`"
                             :name="`formValuesProduct[${product.id}].additional_cost`" class="form-control"/>
                      <ErrorMessage :name="`formValuesProduct[${product.id}].additional_cost`" class="error-feedback"/>
                    </div>
                  </div>

                </div>
                <hr>
                <h5 class="font_700 my-4">Delivery Milestones</h5>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="label">Sample Lead Time (in days)</label>
                      <Field @keydown.space="preventLeadingSpace"
                             :v-model="`formValuesProduct[${product.id}].sample_lead_time`" type="number"
                             :name="`formValuesProduct[${product.id}].sample_lead_time`" class="form-control"/>
                      <ErrorMessage :name="`formValuesProduct[${product.id}].sample_lead_time`" class="error-feedback"/>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="label">Production Lead Time (in days)<span class="required">*</span></label>
                      <Field @keydown.space="preventLeadingSpace"
                             :v-model="`formValuesProduct[${product.id}].production_lead_time`" type="number"
                             :name="`formValuesProduct[${product.id}].production_lead_time`" class="form-control"/>
                      <ErrorMessage :name="`formValuesProduct[${product.id}].production_lead_time`"
                                    class="error-feedback"/>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="label">Delivery (in days)<span class="required">*</span></label>
                      <Field @keydown.space="preventLeadingSpace"
                             :v-model="`formValuesProduct[${product.id}].finish_time`" type="number"
                             :name="`formValuesProduct[${product.id}].finish_time`" class="form-control"/>
                      <ErrorMessage :name="`formValuesProduct[${product.id}].finish_time`" class="error-feedback"/>
                    </div>
                  </div>
                </div>
                <hr/>
                <h5 class="font_700 my-4">Packaging Details</h5>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="label">Packaging Type <span class="required">*</span></label>
                      <Field @keydown.space="preventLeadingSpace"
                             :v-model="`formValuesProduct[${product.id}].packaging_type`"
                             :name="`formValuesProduct[${product.id}].packaging_type`" type="text"
                             class="form-control"/>
                      <ErrorMessage :name="`formValuesProduct[${product.id}].packaging_type`" class="error-feedback"/>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="label">Quantity/Item <span class="required">*</span></label>
                      <Field @keydown.space="preventLeadingSpace"
                             :v-model="`formValuesProduct[${product.id}].quantity_per_box`"
                             :name="`formValuesProduct[${product.id}].quantity_per_box`" type="number"
                             class="form-control"/>
                      <ErrorMessage :name="`formValuesProduct[${product.id}].quantity_per_box`" class="error-feedback"/>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="label">Packaging Weight/Item <span class="required">*</span></label>
                      <Field @keydown.space="preventLeadingSpace"
                             :v-model="`formValuesProduct[${product.id}].package_weight`"
                             :name="`formValuesProduct[${product.id}].package_weight`" type="text"
                             class="form-control"/>
                      <ErrorMessage :name="`formValuesProduct[${product.id}].package_weight`" class="error-feedback"/>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <label class="label">Unit <span class="required">*</span></label>
                      <Field :v-model="`formValuesProduct[${product.id}].package_weight_unit`"
                             :name="`formValuesProduct[${product.id}].package_weight_unit`"
                             as="select"
                             class="form-control form-select">
                        <option>Select Weight Unit</option>
                        <option value="kg">Kilogram</option>
                        <option value="lb">Pound</option>
                      </Field>
                      <ErrorMessage :name="`formValuesProduct[${product.id}].package_weight_unit`"
                                    class="error-feedback"/>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="label">Packaging Length <span class="required">*</span></label>
                      <Field @keydown.space="preventLeadingSpace"
                             :v-model="`formValuesProduct[${product.id}].package_length`" type="text"
                             :name="`formValuesProduct[${product.id}].package_length`" class="form-control"/>
                      <ErrorMessage :name="`formValuesProduct[${product.id}].package_length`" class="error-feedback"/>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="label">Packaging Width <span class="required">*</span></label>
                      <Field @keydown.space="preventLeadingSpace"
                             :v-model="`formValuesProduct[${product.id}].package_width`" type="text"
                             :name="`formValuesProduct[${product.id}].package_width`" class="form-control"/>
                      <ErrorMessage :name="`formValuesProduct[${product.id}].package_width`" class="error-feedback"/>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="label">Packaging Height <span class="required">*</span></label>
                      <Field @keydown.space="preventLeadingSpace"
                             :v-model="`formValuesProduct[${product.id}].package_height`" type="text"
                             :name="`formValuesProduct[${product.id}].package_height`" class="form-control"/>
                      <ErrorMessage :name="`formValuesProduct[${product.id}].package_height`" class="error-feedback"/>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <label class="label">Unit <span class="required">*</span></label>
                      <Field :v-model="`formValuesProduct[${product.id}].package_size_unit`"
                             :name="`formValuesProduct[${product.id}].package_size_unit`"
                             as="select"
                             class="form-control form-select">
                        <option>Select Unit</option>
                        <option value="mm">Millimeter</option>
                        <option value="cm">Centimeter</option>
                        <option value="in">Inches</option>
                        <option value="ft">Foot</option>
                      </Field>
                      <ErrorMessage :name="`formValuesProduct[${product.id}].package_size_unit`"
                                    class="error-feedback"/>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="label">Additional Details</label>
                      <editor
                          api-key="ib23r73dw4tplnpttr0jwef67tx2w0e9m4x6mhdi4simy6uh"
                          :data-index="`${product.id}`" @keyup="(event) => onChangeTextArea(product.id,event)"
                          :v-model="`supplier_additional_details[${product.id}]`"
                          :name="`products[${prod_index}].supplier_quotation_additional_details`"
                          :init="{
                                    menubar: false,
                                    plugins: 'lists link',
                                    toolbar: 'bold italic | bullist'
                                  }"
                      />
                      <!-- <textarea  :data-index="`${product.id}`" @change="onChangeTextArea" :v-model="`formValuesProduct[${product.id}].supplier_quotation_additional_details`" :name="`products[${index}].supplier_quotation_additional_details`" class="form-control form-area"></textarea> -->

                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="label">Attachment</label>
                      <input @change="onChangeFile" :data-index="`${product.id}`"
                             :v-model="`formValuesProduct[${product.id}].supplier_quotation_doc`" type="file"
                             :name="`formValuesProduct[${product.id}].supplier_quotation_doc`" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div><!-- Item Ends Here -->
        <hr class="my-5">
        <!-- Supplier Info -->
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="label">Prepared By<span class="required"></span></label>
              <input @change="onChangeTextPreparedBy" type="text" :value="currentUser.name" name="prepared_by"
                     class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="label">Payment Terms <span class="required"></span></label>
              <editor
                  api-key="ib23r73dw4tplnpttr0jwef67tx2w0e9m4x6mhdi4simy6uh"
                  v-model="payment_terms"
                  :init="{
                    menubar: false,
                    plugins: 'lists link',
                    toolbar: 'bold italic | bullist'
                  }"
              />
              <!-- <textarea @change="onChangeTextAreaPaymentTerms" v-model="supplier_payment_terms" :name="supplier_payment_terms" class="form-control form-area"></textarea> -->
              <!-- <Field @keydown.space="preventLeadingSpace"  v-model="payment_terms" name="payment_terms" class="form-control" />
              <ErrorMessage :name="payment_terms" class="error-feedback" />  -->
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="label">Comments</label>
              <editor
                  api-key="ib23r73dw4tplnpttr0jwef67tx2w0e9m4x6mhdi4simy6uh"
                  v-model="supplier_rfq_comments"
                  :init="{
                    menubar: false,
                    plugins: 'lists link',
                    toolbar: 'bold italic | bullist'
                  }"
              />
              <!-- <textarea @change="onChangeTextAreaRFQ" v-model="supplier_rfq_comments" :name="supplier_rfq_comments" class="form-control form-area"></textarea> -->
            </div>
          </div>
        </div>
        <div class="alert validation-alert" role="alert">
          
        </div>
        <div class="mt-3 text-end">
          <button type="submit" class="btn btn-primary">Create Quotation</button>
        </div>
      </Form>
      <div class="text-end mt-5" style="display: none;">
        <button @click="DeclineRFQ" v-if="rfq_status == 1" type="button" class="btn btn-secondary">Decline RFQ</button>
        <button @click="adjustRFQ" v-if="rfq_status == 1" type="button" class="btn btn-gray ms-2">Adjust RFQ</button>
        <button @click="createQuotation" v-if="rfq_status == 1" type="button" class="btn btn-primary ms-2">Create
          Quotations
        </button>
      </div>
    </div>

    <div class="sweet_overlay" v-if="showDeclineRFQ">
      <div class="sweet_modal">
        <div class="sweet_header">
          <span class="material-icons-outlined">info</span>
        </div>
        <div class="sweet_title">Decline</div>
        <div class="sweet_text">Are you sure you want to decline this RFQ?</div>
        <div class="sweet_footer">
          <button @click="cancelRFQConfirm" class="sweet_button sweet_button_cancel">Cancel</button>
          <button @click="declineRFQConfirm" class="sweet_button sweet_button_danger">Yes</button>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import {Form, Field, ErrorMessage} from "vee-validate";

import * as yup from "yup";
import $ from "jquery";
import Editor from '@tinymce/tinymce-vue'

export default {
  name: "CreateQuotation",
  components: {
    Form,
    Field,
    ErrorMessage,
    'editor': Editor
  },
  data() {

    
    yup.addMethod(yup.string, 'requiredIf', function(list, message) {
      
      return this.test('requiredIf', message, function(value) {
        const { path, createError, parent, options } = this;
        //console.log($(this));
        console.log(options.index);
        //console.log(parent);
        // check if any in list contain value
        // true : one or more are contains a value
        // false: none contain a value
        var anyHasValue = false;
        $.each(parent, function(i, v){
          if(!i.includes("label") && i.includes("price_per_quantity") ){
            if(v){
              anyHasValue = true;
            }
          }
        });

        /*var anyHasValue = list.some(value => {
          console.log(value);

          // return `true` if value is not empty, return `false` if value is empty
          //return Boolean(document.querySelector(`input[name="${value}"]`).value);
          return false;
        });*/


        console.log('-----------------------------------------');
        //console.log(value);
        //console.log(path);
        //const path_new = 'qty_err';

        // returns `CreateError` current value is empty and no value is found, returns `false` if current value is not empty and one other field is not empty.
        return !value && !anyHasValue
          ? createError({ path, message })
          : true;
      });
    });
    yup.addMethod(yup.string, 'generalError', function(list, message) {
      
      return this.test('generalError', message, function(value) {
        
        console.log(value);

        //var msg = "";
        setTimeout(function(){

          if($('.error-feedback').length){

            $('.validation-alert').html($('.error-feedback').html()).addClass('alert-danger');
            
          }else{
            $('.validation-alert').html('').removeClass('alert-danger')
          }

        }, 500);

        
        
      });
    });

    const decimal = /^[0-9]\d*(\.\d+)?$/
    
    

    const schema = yup.object().shape({
      formValuesProduct: yup.array().of(
          yup.object().shape({
            packaging_type: yup.string().required("Package Type is required."),
            quantity_per_box: yup.number().typeError('You must specify a number').required("Quantity per box is required."),
            package_height: yup.string().matches(decimal, 'You must add number or digit e.g 9 or 9.2').required("Package height is required."),
            package_width: yup.string().matches(decimal, 'You must add number or digit e.g 9 or 9.2').required("Package width is required."),
            package_length: yup.string().matches(decimal, 'You must add number or digit e.g 9 or 9.2').required("Package length is required."),
            package_weight: yup.string().matches(decimal, 'You must add number or digit e.g 9 or 9.2').required("Package weight per piece is required."),
            package_weight_unit: yup.string().required("Weight unit is required."),
            package_size_unit: yup.string().required("Hight/Width/length unit is required."),
            // sample_lead_time: yup.number().typeError('You must specify a number').required("Sample lead time is required."),
            production_lead_time: yup.number().typeError('You must specify a number').required("Production lead time is required."),
            finish_time: yup.number().typeError('You must specify a number').required("Completion time is required."),
            tooling_cost: yup.string().matches(decimal, 'You must add number or digit e.g 9 or 9.2'),
            additional_cost: yup.string().matches(decimal, 'You must add number or digit e.g 9 or 9.2'),
            price_per_quantity_label0: yup.number().typeError('You must specify a number').required("Quantity is required"),
            price_per_quantity_label1: yup.number().typeError('You must specify a number'),
            price_per_quantity_label2: yup.number().typeError('You must specify a number'),
            price_per_quantity_label3: yup.number().typeError('You must specify a number'),
            price_per_quantity_label4: yup.number().typeError('You must specify a number'),


            


            /*price_per_quantity_0: yup.string().matches(decimal, 'You must add number or digit e.g 9 or 9.2').required("Price for 1 quantities is required"),
            price_per_quantity_1: yup.string().matches(decimal, 'You must add number or digit e.g 9 or 9.2'),
            price_per_quantity_2: yup.string().matches(decimal, 'You must add number or digit e.g 9 or 9.2'),
            price_per_quantity_3: yup.string().matches(decimal, 'You must add number or digit e.g 9 or 9.2'),*/
            //price_per_quantity_4: yup.string().matches(decimal, 'You must add number or digit e.g 9 or 9.2'),


            price_per_quantity_0: yup.string().requiredIf(['price_per_quantity_0'], "Please provide price for at least one quantity"),//.generalError([], "Please provide price for at least one quantity"),

            basicDetails: yup.string().generalError([], "Please provide price for at least one quantity"),


            /*price_per_quantity_one: yup.string().matches(decimal, 'You must add number or digit e.g 9 or 9.2').required("Price for 1 quantities is required"),
            price_per_quantity_ten: yup.string().matches(decimal, 'You must add number or digit e.g 9 or 9.2').required("Price for 10 quantities is required"),
            price_per_quantity_hundrad: yup.string().matches(decimal, 'You must add number or digit e.g 9 or 9.2').required("Price for 100 quantities is required"),
            price_per_quantity_thousand: yup.string().matches(decimal, 'You must add number or digit e.g 9 or 9.2').required("Price for 1000 quantities is required"),
            price_per_quantity_ten_thousand: yup.string().matches(decimal, 'You must add number or digit e.g 9 or 9.2').required("Price for 10000 quantities is required"),*/
          })
      ),
    });

    const validateNestedSchema = async (formValuesProduct) => {
      const validationResult = await schema
        .validate(formValuesProduct, { abortEarly: false })
        .catch((err) => {
          console.log(err);
          return err;
        });
      console.log(validationResult, ' --------- ', validationResult);
      console.log(validationResult.inner[0].path);
    };
    console.log("validateNestedSchema");
    console.log(validateNestedSchema);



    return {
      rfq_id: null,
      manufacturing_methods: null,
      rfqResp: null,
      manufacturing_method_count: 0,
      products: null,
      rfq_status: null,
      product_count: 0,
      showDeclineRFQ: false,
      showLoader: false,
      schema,
      supplier_additional_details: [],
      supplier_quotation_doc: [],
      supplier_rfq_comments: '',
      prepared_by: '',
      payment_terms: '',
      product_document_file: null,
      formValuesProduct: [{
        packaging_type: "",
        quantity_per_box: '',
        package_height: '',
        package_width: '',
        package_length: '',
        package_size_unit: 'mm',
        supplier_quotation_doc: null,
        package_weight: '',
        package_weight_unit: 'kg',
        finish_time: 1,
        sample_lead_time: 0,
        production_lead_time: 1,
        additional_cost: '',
        tooling_cost: 1,
        price_per_quantity_label0: '',
        price_per_quantity_label1: '',
        price_per_quantity_label2: '',
        price_per_quantity_label3: '',
        price_per_quantity_label4: '',
        price_per_quantity_0: '',
        price_per_quantity_1: '',
        price_per_quantity_2: '',
        price_per_quantity_3: '',
        price_per_quantity_4: '',
        price_per_quantity_one: '',
        price_per_quantity_ten: '',
        price_per_quantity_hundrad: '',
        price_per_quantity_thousand: '',
        price_per_quantity_ten_thousand: ''
      }],
      API_URL: process.env.VUE_APP_API_URL,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  mounted() {
    this.rfq_id = this.$route.params.id;
    this.prepared_by = this.currentUser.name;
    this.geInquiry();
    if (!this.currentUser) {
      this.$router.push('/login');
    }
  },
  methods: {
    onChangeTextArea(id, event) {
      // var data_index_notes = event.target;
      this.supplier_additional_details[id] = event.target.innerHTML;
    },
    onChangeTextAreaPaymentTerms() {
      // this.payment_terms = event.target.value;

    },
    onChangeTextAreaRFQ() {
      // this.supplier_rfq_comments = event.target.value;
    },
    onChangeTextPreparedBy(event) {
      this.prepared_by = event.target.value;
    },
    onChangeFile(event) {
      var data_index_notes = event.target.getAttribute('data-index');
      this.supplier_quotation_doc[data_index_notes] = event.target.files[0];
    },
    preventLeadingSpace(e) {
      // only prevent the keypress if the value is blank
      if (!e.target.value) e.preventDefault();
      // otherwise, if the leading character is a space, remove all leading white-space
      else if (e.target.value[0] == ' ') e.target.value = e.target.value.replace(/^s*/, "");
    },
    back_rfqs() {
      this.$router.push('/request-for-quotations');
    },
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    handleQuotation(quotation) {
      console.log(quotation);
      var store = this.$store;
      var route = this.$router;
      this.showLoader = true;
      var products = quotation.formValuesProduct;
      var formdata = new FormData();
      formdata.append("rfq_id", this.rfq_id);
      formdata.append("api_token", this.currentUser.accessToken);
      formdata.append("payment_terms", this.payment_terms);
      formdata.append("prepared_by", this.prepared_by);
      formdata.append("supplier_rfq_comments", this.supplier_rfq_comments);
      products.forEach((product, index) => {
        console.log(product);
        console.log(index);
        formdata.append("product_id[" + index + "]", index);
        formdata.append("additional_cost[" + index + "]", product.additional_cost);
        formdata.append("finish_time[" + index + "]", product.finish_time);
        formdata.append("package_width[" + index + "]", product.package_width);
        formdata.append("package_height[" + index + "]", product.package_height);
        formdata.append("package_length[" + index + "]", product.package_length);
        formdata.append("package_size_unit[" + index + "]", product.package_size_unit);
        formdata.append("package_weight[" + index + "]", product.package_weight);
        formdata.append("package_weight_unit[" + index + "]", product.package_weight_unit);
        formdata.append("packaging_type[" + index + "]", product.packaging_type);
        formdata.append("price_per_quantity_label0[" + index + "]", product.price_per_quantity_label0);
        formdata.append("price_per_quantity_label1[" + index + "]", product.price_per_quantity_label1);
        formdata.append("price_per_quantity_label2[" + index + "]", product.price_per_quantity_label2);
        formdata.append("price_per_quantity_label3[" + index + "]", product.price_per_quantity_label3);
        formdata.append("price_per_quantity_label4[" + index + "]", product.price_per_quantity_label4);
        formdata.append("price_per_quantity_0[" + index + "]", product.price_per_quantity_0);
        formdata.append("price_per_quantity_1[" + index + "]", product.price_per_quantity_1);
        formdata.append("price_per_quantity_2[" + index + "]", product.price_per_quantity_2);
        formdata.append("price_per_quantity_3[" + index + "]", product.price_per_quantity_3);
        formdata.append("price_per_quantity_4[" + index + "]", product.price_per_quantity_4);

        formdata.append("production_lead_time[" + index + "]", product.production_lead_time);
        formdata.append("quantity_per_box[" + index + "]", product.quantity_per_box);
        formdata.append("sample_lead_time[" + index + "]", product.sample_lead_time);
        formdata.append("tooling_cost[" + index + "]", product.tooling_cost);
        console.log(this.supplier_quotation_doc[index]);
        if (this.supplier_additional_details[index] !== undefined) {
          formdata.append("supplier_additional_details[" + index + "]", this.supplier_additional_details[index]);
        } else {
          formdata.append("supplier_additional_details[" + index + "]", '');
        }
        if (this.supplier_quotation_doc[index] !== undefined) {
          formdata.append("supplier_quotation_doc[" + index + "]", this.supplier_quotation_doc[index]);
        } else {
          formdata.append("supplier_quotation_doc[" + index + "]", '');
        }
      });
      // console.log(formdata);
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + this.currentUser.accessToken);

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.API_URL + "supplier/create-quotation", requestOptions)
          .then(response => response.text())
          .then(result => {
            console.log(result);
            var response = JSON.parse(result);
            if (response.message == 'Token not found.' || response.message == 'something went wrong with inquiry/token information.') {
              this.$toast.show("Your token expired, please login again.", {
                type: "info",
                dismissible: true,
                position: 'top',
                duration: 3500,
                pauseOnHover: true,
                // all of other options may go here
              });
              this.showLoader = false;
              store.dispatch('auth/logout');
              route.push('/login');
            } else {
              this.$toast.show("Quotation submitted Successfylly.", {
                type: "success",
                dismissible: true,
                position: 'top',
                duration: 3500,
                pauseOnHover: true,
                // all of other options may go here
              });
              this.showLoader = false;
              route.push('/request-for-quotations');
            }
          })
          .catch(error => {
            this.$toast.show("Something went wrong!", {
              type: "error",
              dismissible: true,
              position: 'top',
              duration: 3500,
              pauseOnHover: true,
              // all of other options may go here
            });
            console.log(error);
            this.showLoader = false;
          });
    },
    cancelRFQConfirm() {
      this.showDeclineRFQ = false;
    },
    adjustRFQ() {

    },
    DeclineRFQ() {
      this.showDeclineRFQ = true;
    },
    createQuotation() {
      this.$router.push('/create-quotation/' + this.rfq_id);
    },
    geInquiry() {
      var store = this.$store;
      var route = this.$router;
      this.showLoader = true;
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + this.currentUser.accessToken);
      var formdata = new FormData();
      formdata.append("rfq_id", this.rfq_id);
      formdata.append("api_token", this.currentUser.accessToken);

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.API_URL + "supplier/rfq-detail", requestOptions)
          .then(response => response.text())
          .then(result => {
            var response = JSON.parse(result);
            if (response.message == 'Token not found.') {
              this.showLoader = false;
              store.dispatch('auth/logout');
              route.push('/login');
            } else {
              this.manufacturing_methods = response.data.Product_Insterests;
              this.manufacturing_method_count = this.manufacturing_methods.length;
              this.products = response.data.products;
              this.rfqResp = response.data.rfqResp;
              this.product_count = this.products.length;
              this.showLoader = false;
              this.rfq_status = response.data.rfq_status;
            }
          })
          .catch(error => console.log('error', error));
    },
  },
};
</script>
<style scoped>
label {
  display: block;
  margin-top: 10px;
  font-size: 12px;
}

.error-feedback {
  color: red;
}
</style>